export default {
  methods: {
    jumpTo(val) {
      const domains = [
        'https://world-greassist.xyz',
        'https://world-greassist.top',
        'https://world-greassist.vip',
        'https://world-greassist.com',
        'https://greassistant.com'
      ];
      const domain = domains[Math.floor(Math.random() * domains.length)];
      if (val == 1) {
        window.location.href = domain;
      } else {
        window.location.href = domain + '/#/register';
      }
    }
  }
}